module.exports = __webpack_public_path__ + "static/media/bi.0afee182.svg";